<template>
  <nav class="navbar p-0 bg-secondary m-0">
    <div class="container">
      <router-link
        class="d-block navbar-brand p-4 align-self-stretch text-white m-0 flex-fill"
        to="/"
      >
        <img src="@/assets/logo-visit-ouest.svg">
      </router-link>
      <div class="event-infos d-none d-md-flex ml-auto mr-4 text-white">
        <div class="px-2">
          <div>{{dayRange}}</div>
          <div>{{month}}</div>
        </div>
        <div class="px-2 border-left">
          <div>RENNES</div>
          <div>FRANCE</div>
        </div>
      </div>
      <a
        class="p-3 bg-white text-center"
        href="http://www.space.fr/"
        target="_blank"
        rel="noopener"
      >
        <img src="@/assets/logo-space.png" class="img-fluid">
      </a>
    </div>
  </nav>
</template>

<script>
import moment from "moment";

export default {
  name: "Header",
  computed: {
    dayRange() {
      return (
        moment(this.event.startDate).format("DD") +
        " - " +
        moment(this.event.endDate).subtract(1, 'd').format("DD")
      );
    },
    month() {
      return moment(this.event.startDate).format("MMM");
    }
  },
  firestore() {
    return {
      event: this.$db.collection("common").doc("event")
    };
  }
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 82px;

  .navbar-brand {
    background: rgba(0, 0, 0, 0.2);
    max-width: 300px;
  }

  .event-infos {
    line-height: 15px;
    font-size: 0.9em;
    font-weight: bold;
  }
}
</style>
